import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import LandingPage from '../pages/LandingPage';
import { getDashboardPath } from '../utils/rolePaths';

const PublicHome = () => {
  const { isAuthenticated, role, user, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-zinc-50 dark:bg-zinc-950">
        <p className="text-zinc-600 dark:text-zinc-400">Loading...</p>
      </div>
    );
  }

  if (isAuthenticated && role) {
    return <Navigate to={getDashboardPath(role, user)} replace />;
  }

  return <LandingPage />;
};

export default PublicHome;
